import { getPortfolio, getPortfolioFromAssetClasses } from './sharedMapping.js';

export default {
  getPortfolio,
  getPortfolioFromAssetClasses
};
